module.exports = __webpack_public_path__ + "media/images/share-messanger-4898d4c48fa525c0052c349b83a44667.svg";